<template>
  <CardRow
    :label="label"
    :value="getText"
    :disabled="disabled"
    :error-messages="errorMessages"
    :required="required"
    :hideBorderBottom="hideBorderBottom"
  >
    <UIAutocomplete
      v-model="dataValue"
      hide-details
      :placeholder="placeholder"
      :loading="loading"
      :items="items"
      :item-value="itemValue"
      :item-text="itemText"
      :disabled="disabled"
      :item-disabled='itemDisabled'
      :multiple="multiple"
      :return-object="returnObject"
      :no-filter="noFilter"
      :error-messages="errorMessages"
      :search-input.sync="search"
      :no-change-height="noChangeHeight"
      :hide-no-data="hideNoData"
      @change="change"
      @input="input"
    />
  </CardRow>
</template>

<script>
import CardRow from './CardRow'
import UIAutocomplete from '../UIAutocomplete'

export default {
  name: 'CardAutocompleteRow',

  props: {
    label: String,
    value: {
      type: [Object, Number, String, Array, null],
      default: null
    },
    items: Array,
    itemText: {
      type: [String, Function],
      default: 'name'
    },
    itemValue: {
      type: String,
      default: 'id'
    },
    returnObject: {
      type: Boolean,
      default: true
    },
    itemDisabled: {
      type: Function,
      default: () => false
    },
    noFilter: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: Array
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Выбрать из списка'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hideBorderBottom: {
      type: Boolean,
      default: false
    },
    searchInput: {
      type: String,
      default: ''
    },
    noChangeHeight: {
      type: Boolean,
      default: false
    },
    hideNoData: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  components: {
    UIAutocomplete,
    CardRow
  },

  data: () => {
    return {
      dataValue: null
    }
  },

  computed: {
    search: {
      get() {
        return this.searchInput
      },
      set(val) {
        this.$emit('update:search-input', val)
        this.$emit('searchData', val)
      }
    },

    getText() {
      if (this.multiple) {
        return this.dataValue
          ? this.dataValue
              .map(el => {
                if (typeof el === 'object') {
                  return el
                    ? typeof this.itemText === 'function'
                      ? this.itemText(el)
                      : el[this.itemText]
                    : 'Название не найдено'
                }
                const item = this.items.find(item => item[this.itemValue] === el[this.itemValue])
                return item
                  ? typeof this.itemText === 'function'
                    ? this.itemText(item)
                    : item[this.itemText]
                  : 'Название не найдено'
              })
              .join(', ')
          : ''
      } else
        return this.dataValue
          ? typeof this.itemText === 'function'
            ? this.itemText(this.dataValue)
            : this.dataValue[this.itemText]
          : null
    }
  },

  methods: {
    change(val) {
      this.$emit('change', val)
    },
    input(val) {
      this.$emit('input', val)
    }
  },

  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.dataValue = val
      }
    }
  }
}
</script>

<style scoped></style>
